import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Check } from 'lucide-react';
export function FinalComparison() {
  const comparisons = [{
    without: 'Apuntes dispersos',
    with: '12 tomos organizados'
  }, {
    without: 'Estudiás de cero',
    with: 'Protocolos listos'
  }, {
    without: 'Finales sin plan',
    with: 'Guía y preguntas'
  }, {
    without: 'Prácticas con miedo',
    with: 'Guías hospitalarias'
  }, {
    without: 'Sin criterio clínico',
    with: 'Casos resueltos'
  }, {
    without: 'Improvisación total',
    with: 'Sistema completo'
  }, {
    without: 'Sin saber qué ves en la placa',
    with: 'Imágenes interpretadas (versión Élite)',
    elite: true
  }, {
    without: 'Sin protocolo de emergencias',
    with: 'Manual Seguro listo (versión Élite)',
    elite: true
  }];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-151">
      <div className="max-w-5xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-154">
            🦴 RESCATE ACADÉMICO™
          </h2>
          <p className="text-xl text-slate-700 mb-2" data-id="element-155">
            El próximo parcial podés volver a improvisar.
          </p>
          <p className="text-xl text-slate-700 mb-6" data-id="element-156">
            O podés entrar con todo resuelto desde hoy.
          </p>
          <p className="text-2xl font-bold text-slate-900" data-id="element-157">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl shadow-lg overflow-hidden border border-slate-200" data-id="element-158">
          <div className="overflow-x-auto" data-id="element-159">
            <table className="w-full" data-id="element-160">
              <thead data-id="element-161">
                <tr className="bg-slate-900 text-white" data-id="element-162">
                  <th className="px-6 py-4 text-left font-bold" data-id="element-163">SIN RESCATE</th>
                  <th className="px-6 py-4 text-left font-bold bg-green-700" data-id="element-164">
                    CON RESCATE
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-165">
                {comparisons.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-slate-50' : 'bg-white'} data-id="element-166">
                    <td className="px-6 py-4" data-id="element-167">
                      <div className="flex items-start gap-2" data-id="element-168">
                        <XCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-169" />
                        <span className="text-slate-700" data-id="element-170">{row.without}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-171">
                      <div className="flex items-start gap-2" data-id="element-172">
                        <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-173" />
                        <span className={`text-slate-700 ${row.elite ? 'font-semibold' : ''}`} data-id="element-174">
                          {row.with}
                        </span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}